import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Loader from "./Layout/Loader";
import PrimeTable from "./PrimeTable/PrimeTable";
import { useAppContext } from "../AppContext";
import mainAxios from "../services/mainAxios";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import moment from "moment";

const CertificateExpirationDate = () => {
  const [certificate, setCertificate] = useState([]);
  const { t } = useTranslation("translations");
  const company = localStorage.getItem("selectedCompany");

  useEffect(() => {
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetCertificateExpirationDates",
      })
      .then((res) => {
        if (res.data.status === true) {
          setCertificate(res.data.content);
        }
      });
  }, [company]);

  const sendEmail=(params)=>{
    mainAxios.post("/notifications/send",{
      params: {
        ...params,notifSubject:"CERTIFICATEEXPIRATION"
      },
    }).then((res)=>{
      if(res.data.status==true){
        toast.success(t(["email.successConfirmationEmail"]), {
          containerId: "all_toast",
        });
      }
    })
  }

  const columns = [
    {
      header: t("subscription.expirationDate"),
      field: "expirationDate",
      sortable: true,
      filter: true,
      body: (row) => row?.expirationDate ? moment(row?.expirationDate).format("DD/MM/YYYY") : "",
      style: { minWidth: "150px" }
    },
    {
      header: t("item.name"),
      field: "name",
      sortable: true,
      filter: true,
      style: { minWidth: "150px" }
    },
    {
      header: t("invoice.Nuis"),
      field: "nuis",
      sortable: true,
      filter: true,
      style: { minWidth: "120px" }
    },
    {
      header: t("email.email"),
      field: "email",
      sortable: true,
      filter: true,
      style: { minWidth: "180px" }
    },
    {
      header: t("email.sendEmail"),
      field: "sendEmail",
      body: (row)=>{
        const {email="",firstLastName="",expirationDate="",name="", mfa="EMAIL"} = row
        return (<div onClick={()=>sendEmail({companyName:name,receiver:email,firstLastName,expirationDate, mfa})} style={{cursor:"pointer"}}>
          <FontAwesomeIcon icon={faPaperPlane} className="mr-2 text-primary" />
          {t("invoice.send")}
        </div>)
      },
      style: { minWidth: "120px" }
    }
  ];

  return certificate ? (
    <>
      <div className="d-flex justify-content-between align-items-center my-2">
        <h3 className="d-flex align-items-center">
          {t("common.certificateExpirationDates")}
        </h3>
      </div>
      <PrimeTable
        columns={columns}
        value={[...certificate]}
        simpleTable={true}
        showSelectColumns={false}
        showFilters={false}
        clearFilters={false}
        searchableKeys={["expirationDate", "name", "nuis", "email"]}
        showGlobalSearch={true}
      />
    </>
  ) : (
    <Loader />
  );
};

export default CertificateExpirationDate;
